import axios from "axios";
import { isLocal } from "../utils/utils&validatation";

const getbaseURL = () => {
    if (isLocal()) return "https://dapi.qrcodechimp.com/";
    return window.location.origin;
};

const apiClient = axios.create({
    baseURL: getbaseURL(),
    withCredentials: true,
    transformRequest: [
        (data, headers) => {
            if (data instanceof URLSearchParams) {
                return data.toString();
            }
            return data;
        },
    ],
});

apiClient.interceptors.request.use(
    async (config) => {
        const url = config.url || "";

        if (url.includes("/api")) {
            const authToken = localStorage.getItem("Authtk");
            if (authToken) {
                config.headers["Authtk"] = authToken;
            }
        }

        await new Promise((resolve) => setTimeout(resolve, 100));

        return config;
    },
    (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    (response) => response.data,
    async (error) => {
        if (
            error.message?.includes("Network Error") &&
            /Safari/i.test(navigator.userAgent) &&
            !error.config.__isRetry
        ) {
            console.warn("Safari CORS glitch detected. Retrying after 100 ms...");
            error.config.__isRetry = true;
            await new Promise((resolve) => setTimeout(resolve, 300));
            return apiClient.request(error.config);
        }

        if (error.response?.status === 401) {
            console.warn("Unauthorized - Redirecting to /login");
            localStorage.removeItem("Authtk");
            window.location.href = "/event-scanner/login";
        }
        return Promise.reject(error);
    }
);

export default apiClient;